import type {
  EntityList,
  PeerPotentialsDrill,
  ProductKpisDrill,
  ProductRow,
  RowText,
} from "@acto/genui-components-schema";

export type EntityRowDrill =
  | (PeerPotentialsDrill & { productIds: string[]; level: number })
  | (ProductKpisDrill & { productGroupIds: string[] });

export interface EntityRow extends RowText {
  /** Never contains the unresolved-product id (nil UUID). */
  productIds: string[];
  drill: EntityRowDrill | null;
}

const UNRESOLVED_PRODUCT_ID = "00000000-0000-0000-0000-000000000000";

export const resolvable = (ids: readonly string[]): string[] => ids.filter((id) => id !== UNRESOLVED_PRODUCT_ID);

const textOf = ({ chip, title, subtitle, value }: RowText): RowText => ({ chip, title, subtitle, value });

const fromProductRow = (row: ProductRow): EntityRow => {
  const entity = row.entity;
  const productIds = resolvable(entity?.ids ?? []);
  const drill = entity?.drill;
  if (!entity || !drill || productIds.length === 0) return { ...textOf(row), productIds, drill: null };

  switch (drill.kind) {
    case "peerPotentials":
      return { ...textOf(row), productIds, drill: { ...drill, productIds, level: entity.level } };
    case "productKpis":
      return { ...textOf(row), productIds, drill: { ...drill, productGroupIds: productIds } };
    default:
      return { ...textOf(row), productIds, drill: null };
  }
};

export const entityListRows = (card: EntityList): EntityRow[] => {
  if (card.rows.entityKind === "product") return card.rows.items.map(fromProductRow);
  return card.rows.items.map((row) => ({ ...textOf(row), productIds: [], drill: null }));
};
